var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { nanoid } from "@reduxjs/toolkit";
import { useCallback, useMemo, useState } from "react";
import { showNotification } from "../../../../redux/commonSlice";
import { useAppDispatch } from "../../../../store/hooks";
import { getMediaType } from "../../../../utils/utils";
import { generateDynamicFormFields } from "../../../common/commonFunctions";
import { ErrorText, Regex, regexValidator, ValidationTypes } from "../../regex/validations";
import { FormItemTypes, IteratorElements, SurfaceElements } from "./dynamicFormBuilder.entity";
var handleInitialFValue = function (formData) {
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    formData === null || formData === void 0 || formData.forEach(function (item) {
        var _item$value, _item$tabs, _item$valueExpr;
        if (!item)
            return;
        if (SurfaceElements.includes(item.type)) {
            handleInitialFValue(item.elements, initialState);
        }
        if (item.type === FormItemTypes.Tabs) {
            item.tabs.forEach(function (tab) {
                handleInitialFValue(tab.elements, initialState);
            });
        }
        if (item.type === FormItemTypes.Accordian && Array.isArray(item.summary)) {
            handleInitialFValue(item.summary, initialState);
        }
        if (item !== null && item !== void 0 && item.valueSetter)
            initialState = _objectSpread(_objectSpread({}, initialState), item === null || item === void 0 ? void 0 : item.valueSetter(initialState, item.value, item));
        else if ((item === null || item === void 0 ? void 0 : item.type) === FormItemTypes.CheckBox)
            initialState[item === null || item === void 0 ? void 0 : item.name] = Boolean(item === null || item === void 0 ? void 0 : item.value);
        else if ((item === null || item === void 0 ? void 0 : item.type) === FormItemTypes.Tabs)
            initialState[item === null || item === void 0 ? void 0 : item.name] = (_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : (_item$tabs = item.tabs) === null || _item$tabs === void 0 || (_item$tabs = _item$tabs[0]) === null || _item$tabs === void 0 ? void 0 : _item$tabs[(_item$valueExpr = item === null || item === void 0 ? void 0 : item.valueExpr) !== null && _item$valueExpr !== void 0 ? _item$valueExpr : 'id'];
        else if (item !== null && item !== void 0 && item.name) {
            initialState[item.name] = item === null || item === void 0 ? void 0 : item.value;
        }
    });
    return initialState;
};
export var useDynamicForm = function (formData) {
    var _this = this;
    var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mode = arguments.length > 2 ? arguments[2] : undefined;
    var onChange = arguments.length > 3 ? arguments[3] : undefined;
    var externalState = arguments.length > 4 ? arguments[4] : undefined;
    var initVal = useMemo(function () { return _objectSpread(_objectSpread({}, handleInitialFValue(formData)), externalState); }, []);
    var _a = useState(initVal), formValues = _a[0], setValues = _a[1];
    var _b = useState({
        isError: false
    }), errors = _b[0], setErrors = _b[1];
    var _c = useState(mode === 'view'), disabled = _c[0], setDisabled = _c[1];
    var dispatch = useAppDispatch();
    var values = formValues;
    if (externalState)
        values = _objectSpread(_objectSpread({}, formValues), externalState);
    var stateUpdater = useCallback(function (e, newValue, currUpdate, field) { return __awaiter(_this, void 0, void 0, function () {
        var _field$setFormState, _await$field$valueSet, _field$valueSetter, otherValues, currValue, updates, modifiedUpdates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (field === null || field === void 0 || (_field$setFormState = field.setFormState) === null || _field$setFormState === void 0 ? void 0 : _field$setFormState.call(field, values, newValue, field))];
                case 1:
                    otherValues = _a.sent();
                    return [4 /*yield*/, (field === null || field === void 0 || (_field$valueSetter = field.valueSetter) === null || _field$valueSetter === void 0 ? void 0 : _field$valueSetter.call(field, values, newValue, field))];
                case 2:
                    currValue = (_await$field$valueSet = _a.sent()) !== null && _await$field$valueSet !== void 0 ? _await$field$valueSet : currUpdate;
                    updates = _objectSpread(_objectSpread(_objectSpread({}, values), otherValues), currValue);
                    setValues(function (prev) { return _objectSpread(_objectSpread({}, prev), updates); });
                    return [4 /*yield*/, (onChange === null || onChange === void 0 ? void 0 : onChange(e, {
                            errors: errors,
                            field: field,
                            mode: mode,
                            value: newValue,
                            state: updates,
                            reason: 'changeEvent'
                        }))];
                case 3:
                    modifiedUpdates = _a.sent();
                    setValues(function (prev) { return _objectSpread(_objectSpread(_objectSpread({}, prev), updates), modifiedUpdates); });
                    return [2 /*return*/, updates];
            }
        });
    }); }, [values, errors, mode, setValues, onChange, externalState]);
    var handleInputChange = useCallback(function (e, newValue, field) { return __awaiter(_this, void 0, void 0, function () {
        var _newValue, name, value, updates;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    name = field.name, value = field.value;
                    newValue = (_newValue = newValue) !== null && _newValue !== void 0 ? _newValue : value !== null && value !== void 0 ? value : null;
                    return [4 /*yield*/, stateUpdater(e, newValue, (_a = {},
                            _a[name] = newValue,
                            _a), field)];
                case 1:
                    updates = _b.sent();
                    if (!(validate && field.type !== FormItemTypes.Custom && !IteratorElements.includes(field.type))) return [3 /*break*/, 3];
                    return [4 /*yield*/, formValidate(updates, [field])];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [values, stateUpdater, externalState, onChange]);
    var handleOptionChange = useCallback(function (e, value, field) { return __awaiter(_this, void 0, void 0, function () {
        var name, _a, valueExpr, _b, multiple, newValue, updates;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    name = field.name, _a = field.valueExpr, valueExpr = _a === void 0 ? 'id' : _a, _b = field.multiple, multiple = _b === void 0 ? false : _b;
                    newValue = multiple ? value !== null && value !== void 0 ? value : [] : value === null || value === void 0 ? void 0 : value[valueExpr];
                    return [4 /*yield*/, stateUpdater(e, value, (_c = {},
                            _c[name] = newValue,
                            _c), field)];
                case 1:
                    updates = _d.sent();
                    if (!validate) return [3 /*break*/, 3];
                    return [4 /*yield*/, formValidate(updates, [field])];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [values, stateUpdater, externalState, onChange]);
    var handleButtonClick = useCallback(function (e, field) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, stateUpdater(e, e, {}, field)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [values, stateUpdater, externalState, onChange]);
    var handleAttachmentChange = useCallback(function (e, files, field) { return __awaiter(_this, void 0, void 0, function () {
        var name;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    name = field.name;
                    return [4 /*yield*/, stateUpdater(e, files, (_a = {},
                            _a[name] = files,
                            _a), field)];
                case 1:
                    _c.sent();
                    if (!validate) return [3 /*break*/, 3];
                    return [4 /*yield*/, formValidate((_b = {},
                            _b[name] = files,
                            _b), [field])];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [values, stateUpdater, externalState, onChange]);
    var handleServerSideErrors = useCallback(function (_data) {
        if (_data) {
            var code = _data.code, error = _data.error;
            if (_data !== null && _data !== void 0 && _data.message) {
                dispatch(showNotification({
                    isOpen: true,
                    message: _data === null || _data === void 0 ? void 0 : _data.message,
                    type: "error"
                }));
            }
            else if (code === "PAYLOADVALERR") {
                var _error$;
                (_error$ = error[0]) === null || _error$ === void 0 || _error$.map(function (_it) {
                    var _Object$keys;
                    var missingProperty = (_it === null || _it === void 0 ? void 0 : _it.params).missingProperty;
                    var message = _it.message, keyword = _it.keyword, instancePath = _it.instancePath;
                    switch (keyword) {
                        case "required":
                            dispatch(showNotification({
                                isOpen: true,
                                message: message,
                                type: "error"
                            }));
                            break;
                        case "errorMessage":
                            var field_1 = instancePath.replace(/\\|\//g, '');
                            var abc = (_Object$keys = Object.keys) === null || _Object$keys === void 0 || (_Object$keys = _Object$keys.call(Object, values)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (it) { return it === field_1; });
                            if (abc) {
                                setErrors(function (prevErrors) {
                                    var _a;
                                    return _objectSpread(_objectSpread({}, prevErrors), {}, (_a = {},
                                        _a[field_1] = message,
                                        _a));
                                });
                            }
                            else {
                                dispatch(showNotification({
                                    isOpen: true,
                                    message: "".concat(field_1, ": ").concat(message),
                                    type: "error"
                                }));
                            }
                            break;
                        case "type":
                            var _field_1 = instancePath.replace(/\\|\//g, '');
                            setErrors(function (prevErrors) {
                                var _a;
                                return _objectSpread(_objectSpread({}, prevErrors), {}, (_a = {},
                                    _a[_field_1] = message,
                                    _a));
                            });
                            break;
                        default:
                            break;
                    }
                });
            }
        }
    }, []);
    var resetForm = useCallback(function (e) {
        var initialValues = handleInitialFValue(formData);
        setValues(initialValues);
        setErrors({});
        onChange === null || onChange === void 0 || onChange(e, {
            state: initialValues,
            errors: {},
            mode: mode,
            reason: 'reset'
        });
    }, []);
    var getListErrors = useCallback(function (formItem, rows) {
        var elements = formItem.elements, getRowId = formItem.getRowId;
        if (!(elements !== null && elements !== void 0 && elements.length) || !(rows !== null && rows !== void 0 && rows.length))
            return;
        var fields = generateDynamicFormFields(elements);
        var error;
        rows === null || rows === void 0 || rows.find(function (row) {
            fields === null || fields === void 0 || fields.find(function (field) {
                var _field$valueGetter, _field$validator, _getRowId;
                if (!(field !== null && field !== void 0 && field.name) || field !== null && field !== void 0 && field.hidden)
                    return false;
                var currValue = ((_field$valueGetter = field.valueGetter) === null || _field$valueGetter === void 0 ? void 0 : _field$valueGetter.call(field, row, field)) || row[field.name];
                var message = ((_field$validator = field.validator) === null || _field$validator === void 0 ? void 0 : _field$validator.call(field, currValue, row)) || getError(field, currValue);
                var rowId = (_getRowId = getRowId === null || getRowId === void 0 ? void 0 : getRowId(row)) !== null && _getRowId !== void 0 ? _getRowId : row === null || row === void 0 ? void 0 : row.id;
                if (message) {
                    error = {
                        id: nanoid(4),
                        field: field.name,
                        value: currValue,
                        label: field === null || field === void 0 ? void 0 : field.label,
                        message: message,
                        rowId: rowId
                    };
                }
                return Boolean(error);
            });
            return Boolean(error);
        });
        return error;
    }, [values, externalState]);
    var getError = useCallback(function (item, value) {
        var _ErrorText$validation;
        if ((value !== null && value !== void 0 ? value : '') === '' || typeof value === 'number' && isNaN(value)) {
            // for value = null/undefined/''
            return item.required ? ErrorText.required : '';
        }
        if (item.type === FormItemTypes.List || item.type === FormItemTypes.Iterator)
            return getListErrors(item, value);
        var validationType = item === null || item === void 0 ? void 0 : item.validation;
        if (!validationType)
            return '';
        var message = '';
        var regex = Regex[validationType];
        message = (_ErrorText$validation = ErrorText[validationType]) !== null && _ErrorText$validation !== void 0 ? _ErrorText$validation : ErrorText.invalid;
        switch (validationType) {
            case ValidationTypes.number:
            case ValidationTypes.mobile:
            case ValidationTypes.decimalNumber:
                if (item.type === FormItemTypes.TextInput || item.type === FormItemTypes.NumberInput)
                    message = regexValidator(value, regex) ? '' : message;
                break;
            default:
                message = regexValidator(value, regex) ? '' : message;
                break;
        }
        return message;
    }, [values, externalState, getListErrors]);
    var formValidate = useCallback(function (state, fields) {
        var temp = {};
        var isError = false;
        fields === null || fields === void 0 || fields.forEach(function (item) {
            var _item$valueGetter, _item$validator;
            if (!item || item.hidden)
                return;
            var currValue = ((_item$valueGetter = item.valueGetter) === null || _item$valueGetter === void 0 ? void 0 : _item$valueGetter.call(item, state, item)) || state[item.name];
            var err = ((_item$validator = item.validator) === null || _item$validator === void 0 ? void 0 : _item$validator.call(item, currValue, state)) || getError(item, currValue);
            if (err) {
                isError = true;
                console.info(item.name, '|', err);
                // log error
                temp[item.name] = err;
            }
            else
                temp[item.name] = false;
        });
        temp.isError = isError;
        setErrors(function (prev) { return _objectSpread(_objectSpread({}, prev), temp); });
        // Check if any field has error return false else true.
        return !isError;
    }, [values, setErrors, getError]);
    var attachmentUploader = useCallback(function (fields) { return __awaiter(_this, void 0, void 0, function () {
        var attachmentRequest;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    attachmentRequest = {};
                    return [4 /*yield*/, Promise.allSettled(fields.map(function (it) { return __awaiter(_this, void 0, void 0, function () {
                            var fileList, uploadedFiles;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!it || !(it.type === FormItemTypes.Attachment))
                                            return [2 /*return*/];
                                        fileList = values[it.name];
                                        if (!(fileList !== null && fileList !== void 0 && fileList.length))
                                            return [2 /*return*/];
                                        return [4 /*yield*/, Promise.allSettled(fileList === null || fileList === void 0 ? void 0 : fileList.map(function (file) { return __awaiter(_this, void 0, void 0, function () {
                                                var _it$uploadAttachmentR2, _it$uploadAttachmentA, _it$uploadAttachmentR, res;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            if (!(file instanceof File)) return [3 /*break*/, 2];
                                                            return [4 /*yield*/, ((_it$uploadAttachmentA = it.uploadAttachmentAPI) === null || _it$uploadAttachmentA === void 0 ? void 0 : _it$uploadAttachmentA.call(it, {
                                                                    request: _objectSpread(_objectSpread({}, it.uploadAttachmentRequest), {}, {
                                                                        data: file
                                                                    }),
                                                                    state: values
                                                                }))];
                                                        case 1:
                                                            res = _a.sent();
                                                            if (res !== null && res !== void 0 && res.success)
                                                                return [2 /*return*/, {
                                                                        MediaType: getMediaType(file.type),
                                                                        AttachmentId: res === null || res === void 0 ? void 0 : res.attachmentId,
                                                                        Name: file.name,
                                                                        Size: file.size,
                                                                        Type: file.type,
                                                                        SystemName: (_it$uploadAttachmentR = it.uploadAttachmentRequest) === null || _it$uploadAttachmentR === void 0 ? void 0 : _it$uploadAttachmentR.systemname
                                                                    }];
                                                            else
                                                                return [2 /*return*/];
                                                            return [3 /*break*/, 3];
                                                        case 2: return [2 /*return*/, _objectSpread(_objectSpread({}, file), {}, {
                                                                MediaType: getMediaType(file.Type),
                                                                SystemName: (_it$uploadAttachmentR2 = it.uploadAttachmentRequest) === null || _it$uploadAttachmentR2 === void 0 ? void 0 : _it$uploadAttachmentR2.systemname
                                                            })];
                                                        case 3: return [2 /*return*/];
                                                    }
                                                });
                                            }); }))];
                                    case 1:
                                        uploadedFiles = _a.sent();
                                        attachmentRequest[it.name] = uploadedFiles === null || uploadedFiles === void 0 ? void 0 : uploadedFiles.map(function (it) { return it === null || it === void 0 ? void 0 : it.value; }).filter(Boolean);
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/, attachmentRequest];
            }
        });
    }); }, [values]);
    return {
        values: values,
        setValues: setValues,
        errors: errors,
        setErrors: setErrors,
        handleInputChange: handleInputChange,
        resetForm: resetForm,
        handleServerSideErrors: handleServerSideErrors,
        formValidate: formValidate,
        getError: getError,
        handleOptionChange: handleOptionChange,
        handleAttachmentChange: handleAttachmentChange,
        handleButtonClick: handleButtonClick,
        disabled: disabled,
        setDisabled: setDisabled,
        attachmentUploader: attachmentUploader
    };
};
